import { render } from "./DepartmentsContent.vue?vue&type=template&id=433217ad&ts=true"
import script from "./DepartmentsContent.vue?vue&type=script&lang=ts"
export * from "./DepartmentsContent.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__